export enum Shape {
    RECTANGLE = "rect",
    ROUND = "round"
}